<template>
  <div class="wrapper house">
  
    <div class="main-content">

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style>


html {
    line-height: 1.5;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
    font-weight: normal;
    color: rgba(0,0,0);
}
body{
      font-family: semplicitapro, sans-serif !important;  
    background-color: white;
    color:black;
}


h1, h2, h3, h4, h2 {
    font-family: operetta-12, serif;
    font-style: normal;
    font-weight: 300;
    margin: 0;
    padding: 0;
}

.house {
  max-width: 896px;
  margin: auto;
}

.house header {
    position: relative;
    justify-content: center;
}
header {
    width: 100vw;
    max-width: 896px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.house header:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.background-image-cover, header {
    background-repeat: no-repeat;
    background-size: cover;
}
header picture, header picture>img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

header .header-text {
    text-align: center;
}

.house header .header-text>* {
    position: relative;
}

.house header h1 {
    font-size: 30px;
    line-height: 1.2em;
    color: white;
}

.house header img.header-logo {
    height: 80px;
    margin: 30px 0;
}
.house header .header-text>* {
    position: relative;
}


@media print {
    .no-print, .no-print *
    {
      display: none !important;
    }
    .nobreak
    {
      page-break-inside: avoid;
      break-inside: avoid
    }
    .pagebreak {
        clear: both;
        page-break-after: always;
    }    
    .house header {
      height:auto;
      background-color: #fff;
    }
    .house picture {
      display:none;
    }
    .house h1 {
      display:none;
    }
    .row {
      display: block;
    }
}

</style>
